import React, { useReducer, useEffect } from 'react';
import CustomTextField from '../../../shared/form-controls/custom-text-field/Custom-Text-Field';
import { Button } from '@material-ui/core';
import { selectedHotelSelector } from '../../../layouts/property/propertySlice';
import { useDispatch, useSelector } from 'react-redux';
import { saveOrUpdateRoomConfigs } from '../../../utils/IntegrationsAPIUtils';
import { notificationManager } from '../../../utils/NotificationUtils';
import { formDataValidate } from '../../../utils/formUtils';
import {
  fetchGRERoomList,
  fetchSelectedRoom,
  vendorsSelector,
} from '../../../layouts/configurations/configurationSlice';
import { GRE_MULTI_LIST } from '../../../constants/restaurantConst';
import CustomMultiSelect from '../../../shared/form-controls/custom-multi-select/Custom-Multi-Select';
import CustomSelect from '../../../shared/form-controls/custom-select/Custom-Select';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../utils/loaderSlice';

const GuestRoomExperienceRoomTabDND = (props) => {
  const { typeDndInfo, roomId, showLoader = () => {} } = props;
  const dispatch = useDispatch();
  const selectedHotel = useSelector(selectedHotelSelector);
  const allVendors = useSelector(vendorsSelector);
  const { DND } = allVendors;
  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    code: {
      value: '',
      fieldName: 'DND Code',
      errors: {},
      validations: [],
    },
    provider: {
      value: '',
      fieldName: 'DND Provider',
      errors: {},
      validations: [],
    },
    protocol: {
      value: '',
      fieldName: 'DND Protocol',
      errors: {},
      validations: [],
    },
    id: {
      value: '',
      fieldName: 'ID',
      errors: {},
      validations: ['required'],
    },
  });

  useEffect(() => {
    if (typeDndInfo) {
      const currFields = { ...formData };
      for (let field in currFields) {
        currFields[field].value = typeDndInfo[field];
      }
      setFormData(currFields);
    }
  }, [typeDndInfo]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      try {
        dispatch(stepUpLoaderCount());
        const payload = {};

        for (let field in formData) {
          payload[field] = formData[field].value;
        }

        await saveOrUpdateRoomConfigs(selectedHotel, roomId, 'DND', payload);
        notificationManager('success', 'DND details saved successfully');
        dispatch(fetchGRERoomList(selectedHotel));
        dispatch(fetchSelectedRoom(selectedHotel, roomId));
      } catch (error) {
        if (error?.message) {
          notificationManager('danger', error?.message);
        } else {
          notificationManager('danger', 'DND details save failed');
        }
      } finally {
        dispatch(stepDownLoaderCount());
      }
    }
  };

  const validate = () => {
    const updatedFields = {};
    const isValid = formDataValidate(formData, updatedFields);
    setFormData(updatedFields);
    return isValid;
  };

  return (
    <form className='global-tab' noValidate onSubmit={handleSubmit}>
      <div className='container px-0 d-flex align-items-end flex-column h-100'>
        <div className='row w-100 d-flex mt-2'>
          <div className='row'>
            <div className='col-md-4 mb-3'>
              <CustomTextField
                item={formData.code}
                handleInputChange={(e) => {
                  setFormData({ code: e });
                }}
              />
            </div>
            <div className='col-md-4 mb-3'>
              <CustomSelect
                item={formData.provider}
                handleInputChange={(e) => {
                  setFormData({ provider: e });
                }}
                options={DND}
                labelField='name'
                valueField='id'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4 mb-3'>
              <CustomMultiSelect
                item={formData.protocol}
                handleInputChange={(e) => {
                  setFormData({ protocol: e });
                }}
                options={GRE_MULTI_LIST}
                labelField='name'
                valueField='id'
              />
            </div>
            <div className='col-md-4 mb-3'>
              <CustomTextField
                item={formData.id}
                handleInputChange={(e) => {
                  setFormData({ id: e });
                }}
              />
            </div>
          </div>
        </div>
        <div className='row d-flex mt-auto w-100 pb-4'>
          <div>
            <Button size='large' variant='contained' color='primary' className='me-3' type='submit'>
              Save
            </Button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default GuestRoomExperienceRoomTabDND;
